const AboutRoadmap = () => (
    <div className="section-block replicable-content bkg-grey-ultralight">
        <div className="row flex one-column-on-tablet">
            <div className="column width-4 v-align-middle">
                <div>
                    <h3 className="weight-semi-bold mb-20">Short-term</h3>
                    <p className="lead">메타버스 기반 가상자산 커뮤니티 운영</p>
                    <p>가상자산에 관해 얘기할 수 있는 메타버스 기반 가상자산 커뮤니티를 운영하여 메타버스 운영 노하우와 가상자산의 활용처를 찾습니다.</p>
                </div>
            </div>
            <div className="column width-4">
                <ul className="timeline left box rounded xlarge bkg-white">
                    <li className="timeline-item timeline-section">
                        <h4 className="weight-semi-bold mb-5">흑우촌 메타버스 시작</h4>
                        <span>2023년 1분기</span>
                    </li>
                    <li className="timeline-item">
                        <div className="timeline-info">
                            <span className="weight-semi-bold color-charcoal">2024년 8월</span>
                        </div>
                        <div className="timeline-content">
                            <h4 className="timeline-title weight-semi-bold color-gradient-norse-beauty">흑우촌 메타버스 정식 오픈</h4>
                        </div>
                    </li>
                    <li className="timeline-item">
                        <div className="timeline-info">
                            <span className="weight-semi-bold color-charcoal">2024년 4분기</span>
                        </div>
                        <div className="timeline-content">
                            <h4 className="timeline-title weight-semi-bold color-gradient-norse-beauty">가상자산 프로젝트들과 파트너십</h4>
                        </div>
                    </li>
                    <li className="timeline-item entry-left">
                        <div className="timeline-info">
                            <span className="weight-semi-bold color-charcoal">2025년</span>
                        </div>
                        <div className="timeline-content">
                            <h4 className="timeline-title weight-semi-bold color-gradient-norse-beauty">차세대 메타버스 플랫폼 개발 시작</h4>
                        </div>
                    </li>
                    <li className="timeline-item timeline-section">
                        <h4 className="weight-semi-bold mb-5">차세대 플랫폼 출시 및 이주</h4>
                        <span>2027년 1분기</span>
                    </li>
                </ul>
            </div>
            <div className="column width-4 v-align-middle">
                <div>
                    <h3 className="weight-semi-bold mb-20">Long-term</h3>
                    <p className="lead">높은 몰입감의 메타버스 플랫폼 출시</p>
                    <p>흑우촌 메타버스 운영 노하우를 바탕으로, Unreal Engine 5 기반의 메타버스 플랫폼을 출시합니다.
                        VR 헤드셋과 언리얼엔진의 강력한 그래픽으로 색다른 몰입감을 주는것이 목표입니다.</p>
                </div>
            </div>
        </div>
    </div>
)

export default AboutRoadmap;